<div class="small-devices">
    <div id="main-wrapper">
        <div class="site-wrapper-reveal personalise_content">
            <div class="blog-pages-wrapper section-space--ptb_90">
                <div class="row">
                    <div class="col-lg-1"></div>
                    <!--====== Blogs Sidecolumns Start ======-->
                    <div class="col-lg-4 order-lg-2 order-2">
                        <div class="page-sidebar-content-wrapper page-sidebar-right small-mt__40 tablet-mt__40">
                            <!--====== Blogs Recent Post start ======-->
                            <div
                                class="sidebar-widget blog_sidebarwidget  widgeglobal_section_contentt-blog-recent-post blog_widgetpost wow blog_moveupsidebar move-up">
                                <div class="blog_posttilte sidebar-widget-title global_section_header">Recent Posts
                                </div>
                                <ul class="blog_ulpost">

                                    <li class="blog_lipost">
                                        <a href="/postpandamic" class="blog_listanchortags global_section_content">The
                                            new
                                            wave of Digital Marketing in the Post-Pandemic world</a>
                                    </li>
                                    <li class="blog_lipost">
                                        <a href="/migrate-cloud" class="blog_listanchortags global_section_content">Why
                                            is
                                            cloud migration critical in the covid-19 scenario</a>
                                    </li>
                                    <li class="blog_lipost">
                                        <a href="/h1b-visa" class="blog_listanchortags global_section_content">What is
                                            H1-B
                                            Visa</a>
                                    </li>
                                    <li class="blog_lipost">
                                        <a href="/digital-partner"
                                            class="blog_listanchortags global_section_content">How to
                                            choose your digital partner?</a>
                                    </li>
                                    <li class="blog_lipost">
                                        <a href="/cloud-cost-optimization"
                                            class="blog_listanchortags global_section_content">Cloud optimization
                                            strategies that drove 50% cost savings</a>
                                    </li>
                                </ul>
                            </div>
                            <div
                                class="sidebar-widget  blog_sidebarwidget widget-images wow blog_moveupsidebar move-up">

                            </div>
                        </div>
                    </div>


                    <!--====== Blogs Middele columns Start ======-->

                    <div class="col-lg-7 order-lg-1 order-1">
                        <div class="main-blog-wrap">
                            <div class="single-blog-item">


                                <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                    <img src="../../../assets/images/blogs/pii-banner-image.png" class=" w-100"
                                        alt="blogs banner" style="height:auto !important" />
                                </div>
                                <div class="post-info lg-blog-post-info  wow  blog_moveupsidebar move-up">

                                    <div class="post-title global_section_header ">Client Story: Protecting Personal
                                        Identifiable Information (PII) using AI/ML</div>
                                    <div class="post-meta mt-20">
                                        <div class="post-author">

                                        </div>
                                        <div class="post-date">
                                            <span class="meta-icon"><i class="fa-regular fa-calendar-days"></i></span>
                                            June, 2023
                                        </div>
                                        <div class="post-view">
                                            <span class="meta-icon"> <i class=" fa-solid fa-eye"></i></span>

                                            3 views
                                        </div>
                                        <div class="post-read">
                                            <i class="fa fa-book"></i>
                                            3 min Read
                                        </div>

                                    </div>


                                    <div class="post-title global_section_header  new">Challenge</div>
                                    <div class="blogs_subparacontent blog_content text-black">
                                        <p class="global_section_content  pt-4">The financial services industry operates
                                            and deals with vast amount of confidential client and customer data for
                                            daily business transactions. Due to the perceived value of this data, the
                                            financial services industry is one of the primary targets for data breaches.
                                            In fact, one of the key determinants of the success or failure of a
                                            financial service firm is - how well it balances data sharing flexibility
                                            and data privacy.
                                        </p>
                                        <p class="global_section_content pt-4">
                                            Our renowned client- a wealth management institution, sought a swift and
                                            automated data redaction solution to meet their business requirements. Along
                                            with being able to handle customers’ Personable information competently,
                                            they also wanted to upgrade their data privacy and lineage culture by
                                            imbibing the AI/ML solution into their process.
                                        </p>


                                        <div class="mt-5">
                                            <div class="global_section_header">Solution</div>
                                            <p class="pt-2 global_section_content pt-4">
                                                Having studied our client’s business landscape and the challenges
                                                involved, we built a groundbreaking AI/ML solution for Redaction that
                                                helped WM institutions extract vital information from identity documents
                                                with unmatched accuracy. </p>

                                            <p class="pt-2 global_section_content pt-4">
                                                We employed computer vision, machine learning and rule-based
                                                capabilities to extract and redact entities according to the specifics.
                                                No more erroreneous tasks such as drawing boxes or changing font colors
                                                that can expose sensitive data to search engine indexing – we employ
                                                advanced algorithms that ensures precise redaction every time. </p>

                                        </div>

                                        <div class="mt-5">
                                            <div class="global_section_header">Process</div>
                                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                                <img src="../../../assets/images/blogs/pii-blog1.png" class="img-fluid"
                                                    style="width: 100%; height: auto" alt="blogs pii-blog1" />
                                            </div>
                                            <p class="pt-2 global_section_content pt-4">Our strategy of data redaction
                                                involved custom-built solutions that addressed their several use cases.
                                                However the basic process outlines as below: </p>
                                        </div>

                                    </div>


                                    <div class="mt-5">

                                        <p class="pt-2 global_section_content pt-4 data_collection">
                                            <b> Data Collection:</b> The first step is to collect the relevant data that
                                            needs to be redacted. This may include documents, emails, databases, or any
                                            other sources containing sensitive information.
                                        </p>

                                        <p class="pt-2 global_section_content pt-4  data_collection">
                                            <b> Text Extraction:</b> Once the data is collected, the next step is to
                                            extract the text from the different sources. This can involve converting
                                            documents into machine-readable formats or extracting text from structured
                                            databases.
                                        </p>

                                    </div>



                                    <div class="mt-5">

                                        <p class="pt-2 global_section_content pt-4  data_collection">
                                            <b>Processing:</b> The extracted text is then processed using various
                                            techniques to identify and redact sensitive information. Custom Regular
                                            Expression (REGEX) patterns can be used to search for specific patterns or
                                            formats of sensitive data like social security numbers or credit card
                                            numbers. Named Entity Recognition (NER) algorithms can identify entities
                                            like names, addresses, or medical terms. Rule-based logic and deny lists can
                                            be applied to identify and redact specific keywords or phrases.
                                        </p>

                                        <p class="pt-2 global_section_content pt-4  data_collection">
                                            <b> Algorithm (BERT, Fine-tune BERT):</b> Advanced algorithms like
                                            Bidirectional Encoder Representations from Transformers (BERT) can be
                                            utilized for more complex redaction tasks. BERT-based models can be
                                            fine-tuned on specific datasets to improve the accuracy and effectiveness of
                                            redaction, especially in cases where context and semantics play a crucial
                                            role.
                                        </p>

                                        <p class="pt-2 global_section_content pt-4  data_collection">
                                            <b>Output:</b> The final step is to generate the redacted output. This can
                                            be in the form of updated documents, databases, or reports where the
                                            sensitive information has been replaced or masked. The output should ensure
                                            that the redacted data is effectively removed or obfuscated, while
                                            maintaining the integrity and structure of the original information.
                                        </p>

                                    </div>

                                    <div class="mt-5">
                                        <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                            <img src="../../../assets\images\blogs\pii-blog22.png" class="img-fluid"
                                                style="width: 100%; height: auto" alt="blogs pii-blog2" />
                                            <p class="pt-2 global_section_content pt-4  data_collection">
                                                When it comes to redacting images, we use an advanced AI/ML technology
                                                to detect text lists within the image. Our solution then creates a
                                                bounding box directly on the pixel data, runs it through our algorithm,
                                                and produces a masked image as the result.

                                            </p>
                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header" style="line-height: 50px;">Examples
                                            </div>
                                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                                <img src="../../../assets\images\blogs\pii-blog2.png" class="img-fluid"
                                                    style="width: 100%; height: auto" alt="blogs pii-blog2" />
                                            </div>

                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header">Text Redaction </div>
                                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                                <img src="../../../assets\images\blogs\pii-blog3.png" class="img-fluid"
                                                    style="width: 100%; height: auto" alt="blogs pii-blog3" />
                                            </div>


                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header">Image Redaction </div>
                                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                                <img src="../../../assets\images\blogs\pii-blog4.png" class="img-fluid"
                                                    style="width: 100%; height: auto" alt="blogs pii-blog4" />
                                            </div>


                                        </div>

                                        <div class="mt-5  data_collection">
                                            <div class="global_section_header">Entity extraction </div>

                                            <p class="pt-2 global_section_content pt-4">
                                                We leveraged NER algorithms to identify and extract named entities, such
                                                as people, organizations, and locations, from the text data. It can be
                                                used for fraud detection and trend analysis. </p>

                                        </div>

                                        <div class="mt-5 data_collection ">
                                            <div class="global_section_header" style="line-height: 50px;">Build your
                                                AI/ML solution with us </div>

                                            <p class="pt-2 global_section_content pt-4">
                                                Data redaction is one of the most prominent, one-in-a-thousand
                                                applications of AI/ML, and the possibilities are virtually limitless.
                                                According to a McKinsey report, over 50% of companies have already
                                                incorporated AI into at least one business function, with momentum
                                                continuing to soar.</p>
                                            <p class="pt-2 global_section_content pt-4">
                                                Do you have an AI/ML idea that's been brewing in your mind? Whether it's
                                                optimizing your business processes, enhancing customer experiences, or
                                                revolutionizing your industry, our experts are here to collaborate with
                                                you every step of the way. Together, we'll explore the untapped
                                                potential of AI/ML and turn your idea into reality. </p>

                                        </div>


                                        <div class="mt-5  data_collection">

                                            <p class="pt-2 global_section_content pt-4">
                                                Team up with our AI/ML experts to push the boundaries of innovation.
                                                Talk to us. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--====== Blogs Middele columns End ======-->
                </div>
            </div>
        </div>
    </div>

</div>

<div class="col-lg-12 col-sm-12">
    <div class="main-blog-wrap">
        <div class="single-blog-item">
            <div class="post-info lg-blog-post-info  wow  blog_moveupsidebar move-up">
            </div>
        </div>
    </div>
</div>


<div class="container-fluid hider">

    <div class="post-title global_section_header text-center">Client Story: Protecting Personal Identifiable
        Information (PII) using AI/ML</div>
    <div class="post-meta mt-20" style="display: flex; justify-content: center;">
        <div class="post-author">
        </div>
        <div class="post-date">
            <span class="meta-icon"><i class="fa-regular fa-calendar-days"></i></span>
            June, 2023
        </div>
        <div class="post-view view-item1">
            <span class="meta-icon"> <i class=" fa-solid fa-eye"></i></span>
            3 views
        </div>
        <div class="post-read view-item2">
            <span class="meta-icon"><i class="fa fa-book"></i></span>
            3 min Read
        </div>

    </div>

    <div class="post-feature blog-thumbnail mb-3  wow blog_moveupsidebar move-up text-center">
        <img src="../../../assets/images/blogs/pii-banner-image.png" class="img-fluid"
            style="width: 100%; height: auto !important" alt="blogs pii-banner" />
    </div>

    <div class="row">
        <div class="col-md-5 ">
            <div class="tab m-3">

                <h3 class="pt-3" style="color: #A348E8; font-size:20px !important;"> Table of Contents</h3>
                <hr>
                <li class="tick" style="list-style-type: none; "><a (click)="scrollToSection('challenge')">
                        Challenge</a></li>
                <hr>
                <li class="tick" style="list-style-type: none; "><a (click)="scrollToSection('solution')"> Solution</a>
                </li>
                <hr>
                <li class="tick" style="list-style-type: none; "><a (click)="scrollToSection('process')"> Process</a>
                </li>
                <hr>
                <li class="tick" style="list-style-type: none; "><a (click)="scrollToSection('examples')">Examples</a>
                </li>
                <hr>
                <li class="tick" style="list-style-type: none; "><a (click)="scrollToSection('build')"> Get Started</a>
                </li>
                <div class="tabss">
                    <div
                        class="sidebar-widget blog_sidebarwidget  widgeglobal_section_contentt-blog-recent-post blog_widgetpost wow blog_moveupsidebar move-up ">
                        <div class="blog_posttilte sidebar-widget-title global_section_header  data_collection">Recent Posts</div>
                        <ul class="blog_ulpost">

                            <li class="blog_lipost">
                                <a href="/postpandamic" class="blog_listanchortags global_section_content  data_collection">The new
                                    wave of Digital Marketing in the Post-Pandemic world</a>
                            </li>
                            <li class="blog_lipost">
                                <a href="/migrate-cloud" class="blog_listanchortags global_section_content  data_collection">Why is
                                    cloud migration critical in the covid-19 scenario</a>
                            </li>
                            <li class="blog_lipost">
                                <a href="/h1b-visa" class="blog_listanchortags global_section_content  data_collection">What is H1-B
                                    Visa</a>
                            </li>
                            <li class="blog_lipost">
                                <a href="/digital-partner" class="blog_listanchortags global_section_content  data_collection">How to
                                    choose your digital partner?</a>
                            </li>
                            <li class="blog_lipost">
                                <a href="/cloud-cost-optimization"
                                    class="blog_listanchortags global_section_content  data_collection">Cloud optimization strategies
                                    that drove 50% cost savings</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-7">

            <div class="blogs_subparacontent blog_content text-black">
                <div class="global_section_header" id="challenge">Challenge </div>
                <div>
                    <p class="global_section_content pt-4">The financial services industry operates and deals with vast
                        amount of confidential client and customer data for daily business transactions. Due to the
                        perceived value of this data, the financial services industry is one of the primary targets for
                        data breaches. In fact, one of the key determinants of the success or failure of a financial
                        service firm is - how well it balances data sharing flexibility and data privacy. </p>
                    <p class="global_section_content pt-4">
                        Our renowned client- a wealth management institution, sought a swift and automated data
                        redaction solution to meet their business requirements. Along with being able to handle
                        customers’ Personable information competently, they also wanted to upgrade their data privacy
                        and lineage culture by imbibing the AI/ML solution into their process. </p>
                    <div class="mt-5">
                        <div class="global_section_header" id="solution">Solution </div>
                        <p class="pt-2 global_section_content pt-4">
                            Having studied our client’s business landscape and the challenges involved, we built a
                            groundbreaking AI/ML solution for Redaction that helped WM institutions extract vital
                            information from identity documents with unmatched accuracy. </p>
                        <p class="pt-2 global_section_content pt-4">
                            We employed computer vision, machine learning and rule-based capabilities to extract and
                            redact entities according to the specifics. No more erroreneous tasks such as drawing boxes
                            or changing font colors that can expose sensitive data to search engine indexing – we employ
                            advanced algorithms that ensures precise redaction every time. </p>
                    </div>

                </div>

                <div class="mt-5">
                    <div class="global_section_header" id="process">Process </div>
                    <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                    </div>

                    <div class="container">
                        <div class="row">
                            <div *ngFor="let item of imageItems1" class="col-md-3">
                                <div class="image-item">
                                    <img [src]="item.src" class="w-100" alt="Image" />
                                    <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                                        <span class="search-icon">
                                            <img draggable="false" role="img" class="emoji" alt="🔍"
                                                src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg"
                                                style="height: 20px;">
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="enlargedContainer" *ngIf="isEnlargedVisible" class="enlarged-container">
                            <div class="row enlargedrow">
                                <img id="enlargedImage" [src]="enlargedImageSrc" alt="Enlarged Image" />
                                <span id="backButton" (click)="hideEnlargedImage()">&#8592;</span>
                            </div>
                        </div>
                    </div>
                    <p class="pt-2 global_section_content pt-4">
                        Our strategy of data redaction involved custom-built solutions that addressed their several use
                        cases. However the basic process outlines as below: </p>

                </div>
                <div class="mt-5">

                    <p class="pt-2 global_section_content pt-4">
                        <b>Data Collection:</b> The first step is to collect the relevant data that needs to be
                        redacted. This may include documents, emails, databases, or any other sources containing
                        sensitive information.
                    </p>

                    <p class="pt-2 global_section_content pt-4">
                        <b>Text Extraction:</b> Once the data is collected, the next step is to extract the text from
                        the different sources. This can involve converting documents into machine-readable formats or
                        extracting text from structured databases.
                    </p>

                </div>

                <div class="mt-5">
                    <p class="pt-2 global_section_content pt-4">
                        <b>Processing:</b> The extracted text is then processed using various techniques to identify and
                        redact sensitive information. Custom Regular Expression (REGEX) patterns can be used to search
                        for specific patterns or formats of sensitive data like social security numbers or credit card
                        numbers. Named Entity Recognition (NER) algorithms can identify entities like names, addresses,
                        or medical terms. Rule-based logic and deny lists can be applied to identify and redact specific
                        keywords or phrases.
                    </p>

                    <p class="pt-2 global_section_content pt-4">
                        <b>Algorithm (BERT, Fine-tune BERT):</b> Advanced algorithms like Bidirectional Encoder
                        Representations from Transformers (BERT) can be utilized for more complex redaction tasks.
                        BERT-based models can be fine-tuned on specific datasets to improve the accuracy and
                        effectiveness of redaction, especially in cases where context and semantics play a crucial role.
                    </p>

                    <p class="pt-2 global_section_content pt-4">
                        <b>Output:</b> The final step is to generate the redacted output. This can be in the form of
                        updated documents, databases, or reports where the sensitive information has been replaced or
                        masked. The output should ensure that the redacted data is effectively removed or obfuscated,
                        while maintaining the integrity and structure of the original information.
                    </p>

                </div>

                <div class="mt-5">

                    <div class="container">
                        <div class="row">
                            <div *ngFor="let item of imageItems2" class="col-md-3">
                                <div class="image-item">
                                    <img [src]="item.src" class="w-100" alt="Image" />
                                    <div class="image-overlay" (click)="showEnlargedImage(item.src)">
                                        <span class="search-icon">
                                            <img draggable="false" role="img" class="emoji" alt="🔍"
                                                src="https://s.w.org/images/core/emoji/14.0.0/svg/1f50d.svg"
                                                style="height: 20px;">
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="enlarged-image" id="enlargedContainer">
                            <img src="" alt="Enlarged back" id="enlargedImage">
                            <span class="back-button" id="backButton">&#8592;</span>
                        </div>

                        <p class="pt-2 global_section_content pt-4">
                            When it comes to redacting images, we use an advanced AI/ML technology to detect text lists
                            within the image. Our solution then creates a bounding box directly on the pixel data, runs
                            it through our algorithm, and produces a masked image as the result.

                        </p>
                    </div>

                </div>

                <div class="mt-5">
                    <div class="global_section_header" style="line-height: 50px;" id="examples">Examples </div>
                    <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                        <img src="../../../assets\images\blogs\pii-blog2.png" class=" w-100" alt="blogs pii-blog2" />
                    </div>


                    <div class="mt-5">
                        <div class="global_section_header" style="line-height: 50px;">Text Redaction </div>
                        <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                            <img src="../../../assets\images\blogs\pii-blog3.png" class=" w-100" alt="blogs pii3" />
                        </div>

                        <div class="mt-5">
                            <div class="global_section_header" style="line-height: 50px;">Image Redaction </div>
                            <div class="post-feature blog-thumbnail  wow blog_moveupsidebar move-up">
                                <img src="../../../assets\images\blogs\pii-blog4.png" class="w-100" alt="blogs pii4" />
                            </div>

                        </div>

                        <div class="mt-5">
                            <div class="global_section_header">Entity extraction</div>
                            <p class="pt-2 global_section_content pt-4">
                                We leveraged NER algorithms to identify and extract named entities, such as people,
                                organizations, and locations, from the text data. It can be used for fraud detection and
                                trend analysis.
                            </p>

                        </div>

                        <div class="mt-5">
                            <div class="global_section_header" id="build">Build your AI/ML solution with us </div>

                            <p class="pt-2 global_section_content pt-4">
                                Data redaction is one of the most prominent, one-in-a-thousand applications of AI/ML,
                                and the possibilities are virtually limitless. According to a McKinsey report, over 50%
                                of companies have already incorporated AI into at least one business function, with
                                momentum continuing to soar. </p>
                            <p class="pt-2 global_section_content pt-4">
                                Do you have an AI/ML idea that's been brewing in your mind? Whether it's optimizing your
                                business processes, enhancing customer experiences, or revolutionizing your industry,
                                our experts are here to collaborate with you every step of the way. Together, we'll
                                explore the untapped potential of AI/ML and turn your idea into reality. </p>

                        </div>

                        <div class="mt-5">
                            <div class="global_section_header" style="line-height: 50px;"></div>

                            <p class="pt-2 global_section_content pt-4">
                                Team up with our AI/ML experts to push the boundaries of innovation. Talk to us. </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

